var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.667 10.675H2.82v-6H.667v6Zm10.73-4.322-.935 3.268c-.154.62-.75 1.054-1.435 1.054h-5.13V4.686l.926-3.098c.087-.525.574-.912 1.146-.912.64 0 1.16.482 1.16 1.076v2.924h2.834c.947 0 1.648.82 1.435 1.677Z",
    clipRule: "evenodd"
  })));
};
export default SvgApprove;